import firebase from 'firebase/app';
import { getUserFirestore, getCommentFirestore } from '@/lib/firebase/firestore';
import { v4 as uuidv4 } from 'uuid';

export type Comment = {
  user: {
    uid: string;
    name: string;
    img: string;
    favorited: string[];
    liked: string[];
  };
  commentId: string;
  likedCount: number;
  message: string;
  timestamp: string;
};

export async function fetchCommentShopping(postId: string) {
  try {
    const commentList: Comment[] = [];
    const querySnapshot = await getCommentFirestore()
      .doc('comment')
      .collection(`${postId}`)
      .get();
    await Promise.all(
      querySnapshot.docs.map(async (doc) => {
        if (doc.exists) {
          const comment = (doc.data() as Comment) || {};
          commentList.push(comment);
        }
      })
    );
    return commentList;
  } catch (error) {
    throw new Error();
  }
}

export async function addCommentShopping({
  postId,
  userId,
  message
}: {
  postId: string;
  userId: string;
  message: string;
}) {
  const user = await getUserFirestore()
    .doc(`${userId}`)
    .get()
    .then((res) => res.data());
  try {
    await getCommentFirestore()
      .doc('comment')
      .collection(`${postId}`)
      .add({
        commentId: uuidv4(),
        user,
        message,
        timestamp: Date.now(),
        likedCount: 0
      });
  } catch (error) {
    throw new Error();
  }
}

export async function updateCommentCountShopping({
  postId,
  commentId,
  liked
}: {
  postId: string;
  commentId: string;
  liked: boolean;
}) {
  const querySnapshot = await getCommentFirestore()
    .doc('comment')
    .collection(`${postId}`)
    .get();
  try {
    if (liked) {
      await querySnapshot.docs.map((doc) => {
        const islikedComment = doc.data().commentId === commentId;
        if (doc.exists && islikedComment) {
          getCommentFirestore()
            .doc('comment')
            .collection(`${postId}`)
            .doc(doc.id)
            .update({ likedCount: firebase.firestore.FieldValue.increment(1) });
        }
      });
    } else {
      await querySnapshot.docs.map((doc) => {
        const islikedComment = doc.data().commentId === commentId;
        if (doc.exists && islikedComment) {
          getCommentFirestore()
            .doc('comment')
            .collection(`${postId}`)
            .doc(doc.id)
            .update({ likedCount: firebase.firestore.FieldValue.increment(-1) });
        }
      });
    }
  } catch (error) {
    throw new Error();
  }
}
